import {Expose, Transform, Type} from 'class-transformer';
import {IsArray, IsBoolean, IsObject, IsOptional, IsString, ValidateNested} from 'class-validator';

export class SortedColumn {
	@Expose() @IsString() @IsOptional() @Transform(({value}) => value ?? null) id: string | null = null;
	@Expose() @IsString() @IsOptional() @Transform(({value}) => value ?? null) direction: string | null = null;
}

export class LastFilter {
	@Expose() @IsArray() @IsString({each: true}) @Transform(({value}) => value ?? []) list: string[] = [];
	@Expose() @IsString() @IsOptional() @Transform(({value}) => value ?? null) fromDate: string | null = null;
	@Expose() @IsString() @IsOptional() @Transform(({value}) => value ?? null) toDate: string | null = null;
	@Expose() @IsArray() @IsString({each: true}) @Transform(({value}) => value ?? []) tags: string[] = [];
}

export class UserPreferencesFinderSchema {
	@Expose() @IsBoolean() @Transform(({value}) => value ?? false) lastFilterAllDatesMode: boolean = false;

	@Expose()
	@ValidateNested()
	@Type(() => LastFilter)
	@Transform(({value}) => value ?? new LastFilter())
	lastFilter: LastFilter = new LastFilter();

	@Expose()
	@IsArray()
	@IsString({each: true})
	@Transform(({value}) => value ?? [])
	selectedColumns: string[] = [];

	@Expose()
	@ValidateNested()
	@Type(() => SortedColumn)
	@Transform(({value}) => value ?? new SortedColumn())
	defaultSortedColumn: SortedColumn = new SortedColumn();

	@Expose()
	@IsArray()
	@IsString({each: true})
	@Transform(({value}) => value ?? [])
	columnOrder: string[] = [];

	constructor(init?: DeepPartial<UserPreferencesFinderSchema>) {
		this.lastFilter = new LastFilter();
		this.defaultSortedColumn = new SortedColumn();

		if (init) {
			if (init.lastFilter) {
				Object.assign(this.lastFilter, init.lastFilter);
			}
			if (init.defaultSortedColumn) {
				Object.assign(this.defaultSortedColumn, init.defaultSortedColumn);
			}

			Object.assign(this, {
				...init,
				lastFilter: this.lastFilter,
				defaultSortedColumn: this.defaultSortedColumn,
			});
		}
	}
}
